import { queryOptions, useQuery } from "@tanstack/react-query";
import api from "../api";
import type { SiteOverviewSite } from "../components/SiteStatus/site-status-types";
import urls from "../urls";

export function siteOverviewQuery() {
  return queryOptions({
    queryKey: ["site-overview"],
    queryFn: fetchSiteOverview,
    refetchInterval: false,
    refetchOnWindowFocus: false
  });
}

export function useSiteOverview() {
  return useQuery(siteOverviewQuery());
}

async function fetchSiteOverview() {
  const response = await api.get<Array<SiteOverviewSite>>(
    urls.api.siteOverview()
  );
  return response.data;
}
